/**
 * Trunnion AI - Execution Detail Page
 * /executions/:id
 */

import { useParams } from 'react-router-dom';
import { ExecutionMonitor } from '@/components/execution/ExecutionMonitor';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { EmptyState } from '@/components/ui/EmptyState';
import { useExecution, useCancelExecution } from '@/hooks/queries/useExecutions';
import { useExecutionStream } from '@/hooks/useExecutionStream';
import { executionsApi } from '@/api/executions.api';

export default function ExecutionPage() {
  const { id } = useParams<{ id: string }>();
  const { data: execution, isLoading, error } = useExecution(id ?? '');
  const cancelExecution = useCancelExecution();

  // Subscribe to real-time updates
  useExecutionStream(id ?? null);

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <LoadingSpinner size="lg" label="Loading execution..." />
      </div>
    );
  }

  if (error || !execution) {
    return (
      <EmptyState
        message="Execution not found"
        description="The requested execution could not be loaded."
      />
    );
  }

  return (
    <div className="h-[calc(100vh-theme(spacing.14)-50px)]">
      <ExecutionMonitor
        execution={execution}
        onCancel={() =>
          cancelExecution.mutate({
            id: execution.id,
            reason: 'Cancelled by operator',
          })
        }
        onRetry={async () => {
          await executionsApi.retry(execution.id);
        }}
      />
    </div>
  );
}
